import { Box, Typography } from '@mui/material';
import { ROIState } from '~/state/atoms/structureSet/roiAtoms';
import ROIColor from './ROIColor';

export default function StructureLabel({ roi }: { roi?: ROIState }) {
    return (
        <Box display="flex" alignItems="center" gap={1}>
            {roi?.color && <ROIColor color={roi.color} />}
            <Typography variant="body1">
                {roi?.name ?? 'Unknown structure'}
            </Typography>
        </Box>
    );
}
